import { IMAGE_DIR } from '@/shared/constants/linksApi'
import { MDBCarousel, MDBCarouselItem } from 'mdb-react-ui-kit'

export const CarouselCatalogItem = ({ imagesProduct }) => {
    return (
        <MDBCarousel showControls className={'CarouselCatalogItem'}>
            {imagesProduct.map((item, index) => (
                <MDBCarouselItem itemId={index + 1} key={index}>
                    <img
                        className="carouselItem"
                        src={IMAGE_DIR + item.image}
                        alt="item-product"
                    />
                </MDBCarouselItem>
            ))}
        </MDBCarousel>
    )
}
